import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Head from 'next/head';
import { useTranslation } from '@yoweb/next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var withPageTitle = function withPageTitle(WrappedComponent) {
  return function (_ref) {
    var translationKey = _ref.translationKey,
        translationNS = _ref.translationNS,
        _ref$useTitleTemplate = _ref.useTitleTemplate,
        useTitleTemplate = _ref$useTitleTemplate === void 0 ? true : _ref$useTitleTemplate;
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var WithPageTitle = function WithPageTitle(props) {
      // @ts-ignore improve typing
      var _useTranslation = useTranslation(['common', translationNS]),
          t = _useTranslation.t; // @ts-ignore improve typing


      var title = t("".concat(translationNS, ":").concat(translationKey));
      var completeTitle = useTitleTemplate ? t('titleTemplate', {
        title: title,
        ns: 'common'
      }) : title;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Head, {
          children: /*#__PURE__*/_jsx("title", {
            children: completeTitle
          })
        }), /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, props))]
      });
    };

    WithPageTitle.displayName = displayName;
    return Object.assign(WithPageTitle, WrappedComponent);
  };
};